import { render, staticRenderFns } from "./TotalInfoBlock.vue?vue&type=template&id=4186347a&scoped=true"
import script from "./TotalInfoBlock.vue?vue&type=script&lang=js"
export * from "./TotalInfoBlock.vue?vue&type=script&lang=js"
import style0 from "./TotalInfoBlock.vue?vue&type=style&index=0&id=4186347a&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4186347a",
  null
  
)

export default component.exports